import React from 'react';
import {Col, Row, Container} from 'reactstrap';
import {connect} from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {goToPage} from '../../fundialSlice';

const SubscriberHeader = (props) => {

    return (
            <Row>
                <Col xs="12" sm="12" md="12" >
                    <div className="subscriber-header">
                        <div className="title">
                            <h2>{props.subscriber?.cli}</h2>
                        </div>
                        <div className="content">
                            {props.subscriber?.fundialSubscriberStatus == "PREMIUM" && <div>שירות המתנה נעימה <span className="bold-text">ללא הגבלה</span></div>}
                            {props.subscriber?.fundialSubscriberStatus == "REGULAR" && <div> שירות המתנה בסיסי- הורדת כל שיר בעלות של<span className="bold-text">&nbsp; {props.subscriber?.fundialRegularItemPrice} ₪</span></div>}
                            {props.subscriber?.fundialSubscriberStatus == "UNREGISTERED" && <div>
                                <h3>הצטרפות</h3>
                                <p>שירות המתנה נעימה</p>
                                <p className="bold-text">ללא הגבלה {props.subscriber?.fundialPremiumPackagePrice} ₪ לחודש</p>
                                </div>
                            }
                            {props.subscriber?.fundialSubscriberStatus != "PREMIUM" && <div className="btn-wrapper"><BtnSubmit onclick={() => {props.goToPage({page: 'catalogPage'})}} text={props.subscriber?.fundialSubscriberStatus == "UNREGISTERED" ? "בחרו שיר והצטרפו לשירות": "שדרגו לשרות ללא הגבלה" } formid="fundial-add-contact"></BtnSubmit></div>}                       
                        </div>
                    </div>
                </Col>
            </Row>
    );
};



const mapStateToProps = (state) => {
    return {
      subscriber : state.fundialPage.selectedSubscriber,
    };
  };
  
  const mapDispatchToProps = {
    goToPage
      
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(SubscriberHeader);